import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "../../../core/auth/auth.service";
import {DadosJwtService} from "../../../core/services/dados-jwt.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  sitePjus = 'https://www.pjus.com.br/';

  /**
   * Quando true, força a ocultação das ações autenticadas (sino e avatar/logout),
   * independentemente de haver JWT em cache. Usado em telas públicas como o
   * cadastro de novo parceiro (/novo-parceiro/cadastro).
   */
  @Input() publico = false;

  constructor(
    public authService: AuthService,
    public dadosJwtService: DadosJwtService,
  ) {
  }

  ngOnInit(): void {}

  /**
   * Getter reativo: avaliado a cada ciclo de detecção de mudanças,
   * garantindo que o sino e o avatar apareçam/desapareçam em tempo real
   * conforme o JWT entrar ou sair do localStorage.
   */
  get authUser(): boolean {
    return !this.publico && !!this.dadosJwtService.get()?.jwt;
  }

}
